import { GET_DASHBOARD, GET_DASHBOARD_COUNT } from 'redux/actions/dashboard';

const initialState = {
  list: [],
  board : {}
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD: {
      return {
        ...state,
        list: payload,
      };
    }
    case GET_DASHBOARD_COUNT: {
      return {
        ...state,
        board: payload,
      };
    }
    default:
      return state;
  }
};
